import IcDelete from '@assets/details-camera-icons/IcDelete';
import IcEditGeoZone from '@assets/details-camera-icons/IcEditGeoZone';
import BaseIcon from '@components/BaseIcon';
import { Stack, useTheme } from '@mui/material';
import React from 'react';
import { MdClose, MdDone } from 'react-icons/md';

interface GeoZoneActionButtonsProps {
    isEditing: boolean;
    onEdit: () => void;
    onSave: () => void;
    onCancel: () => void;
    onDelete: () => void;
}

const GeoZoneActionButtons: React.FC<GeoZoneActionButtonsProps> = ({
    isEditing,
    onEdit,
    onSave,
    onCancel,
    onDelete,
}) => {
    const theme = useTheme();

    return (
        <Stack width={'100%'} direction="row" alignItems="flex-end" spacing={0.5}>
            {isEditing ? (
                <Stack direction={'row'} spacing={1} justifyContent={'end'} width={'100%'}>
                    <BaseIcon
                        title="Save"
                        colorHover={theme.palette.secondary.main}
                        children={<MdDone fontSize={'16px'} />}
                        onClick={onSave}
                    />
                    <BaseIcon
                        title="Cancel"
                        colorHover={theme.palette.error.dark}
                        children={<MdClose fontSize={'16px'} />}
                        onClick={onCancel}
                    />
                </Stack>
            ) : (
                <Stack direction={'row'} spacing={1} justifyContent={'end'} width={'100%'}>
                    <BaseIcon
                        title="Edit"
                        colorHover={theme.palette.secondary.main}
                        children={<IcEditGeoZone style={{ width: 14, height: 14 }} />}
                        onClick={onEdit}
                    />
                    <BaseIcon
                        isDelete
                        colorHover={theme.palette.error.main}
                        children={<IcDelete />}
                        onClick={onDelete}
                    />
                </Stack>
            )}
        </Stack>
    );
};

export default GeoZoneActionButtons;
